import styled from 'styled-components';
import { ShortBody } from 'components/Typography';
import { LongBody } from 'components/Typography';

export const StyledShortBody = styled(ShortBody)`
  margin-bottom: 12px !important;
  margin-top: 12px !important;
`;

export const WrapperBar = styled.div`
  margin-top: 10px !important;
`;

export const StyledBodyText = styled.p`
  white-space: pre-line;
  color: #162952;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  max-height: 500px;
  margin: 0px;
  overflow: auto;
`;

export const SizedLongBody = styled(LongBody)`
  && {
    margin-bottom: 0px;
  }
`;

export const GeneralConditions = styled.a`
  color: #1974fe;
  text-decoration: underline;
  cursor: pointer;
`;
